import { Box } from '@mui/material';
import { GridFormatterControls } from 'components/Grid/GridFormatter';
import { useWaterfallFXContext } from 'pages/Waterfall/SpreadsheetConfig/WaterfallFX/WaterfallFXContext/WaterfallFXContext';
import { WaterfallTableFormatterProps } from './WaterfallTableFormatter.props';

const WaterfallTableFormatter = ({
  horizontalOffset = 12,
  placement = 'overlay',
}: WaterfallTableFormatterProps) => {
  const context = useWaterfallFXContext();

  if (!context?.selectedCurrency || !context.standardCurrency) {
    return null;
  }

  const {
    currencyDisplayLabel,
    exchangeRate,
    isLoading,
    onCurrencyChange,
    onUnitsChange,
    selectedCurrency,
    standardCurrency,
    unitDisplayLabel,
    units,
  } = context;
  const isAboveTable = placement === 'above';

  return (
    <Box
      data-testid="waterfall-table-formatter"
      sx={theme => ({
        alignItems: isAboveTable ? 'flex-end' : undefined,
        display: isAboveTable ? 'flex' : undefined,
        height: isAboveTable ? 28 : 0,
        position: 'relative',
        width: '100%',
        '& button': {
          transition: theme.transitions.create(['background-color', 'border-color', 'color'], {
            duration: theme.transitions.duration.shorter,
          }),
        },
        '& button:not(.Mui-disabled):hover': {
          backgroundColor: 'grey.100',
          borderColor: 'grey.400',
          color: 'grey.800',
        },
      })}>
      <GridFormatterControls
        currency={{
          code: selectedCurrency.sourceCurrency,
          exchangeRate: exchangeRate ?? undefined,
          sourceCurrency: standardCurrency,
          symbol: selectedCurrency.symbol,
          units,
        }}
        currencyFormatter
        currencyLabel={currencyDisplayLabel}
        isLoading={isLoading}
        onCurrencyChanged={onCurrencyChange}
        onUnitsChanged={onUnitsChange}
        sx={{
          left: isAboveTable ? undefined : horizontalOffset,
          marginLeft: isAboveTable ? `${horizontalOffset}px` : undefined,
          position: isAboveTable ? 'static' : 'absolute',
          top: isAboveTable ? 0 : '9px',
          whiteSpace: 'nowrap',
          width: 'max-content',
          zIndex: 2,
        }}
        unitsFormatter
        unitsLabel={unitDisplayLabel}
      />
    </Box>
  );
};

export default WaterfallTableFormatter;
